document.addEventListener('alpine:init', () => {
  Alpine.store('lang', {
    current: document.body.dataset.lang,

    languages: [
      {
        code: 'en',
        labels: {
          en: 'EN',
          'zh-hans': 'EN',
        },
      },
      {
        code: 'zh-hans',
        labels: {
          en: '中文',
          'zh-hans': '中文',
        },
      },
    ],

    init() {},
  });
});